export default "__VITE_ASSET__DSxgR7AG__"